<template>
  <BaseModal :modal-name="name" max-width="max-w-2xl" @closed="onClosedModal">
    <div class="w-full">
      <h1 class="pb-3 text-2xl font-medium text-primary">
        {{ $t('block_account.title') }}
      </h1>
      <p
        class="text-xl font-medium text-darkestGray"
        v-html="
          $t('block_account.description', {
            number: `<span class='whitespace-nowrap'>22 349 11 94</span>`,
            email: 'info@alab.com.pl',
          })
        "
      ></p>
    </div>
  </BaseModal>
</template>

<script setup>
import { useAuthStore } from '~/stores/auth'

const name = 'blockedPatientModal'
const { sendLogoutUser } = useIframeSharedMethods()
const authStore = useAuthStore()

const onClosedModal = async () => {
  sendLogoutUser()
  await authStore.logout()

  window.location = useGenerateSharedURL('login')
}
</script>
